<template>
	<div class="wrapper">
		<div class="header" :class="{'header-min': isDetail()}">
			<div class="section-top">
				<!--				<div class="menu-toggle"></div>-->
				<div class="logo" @click="toMainPage()">
					<div class="logo-main"></div>
					<img class="logo-marketplace" src="@/styles/images/logo.svg">
				</div>
			</div>
			<div class="section-bottom" v-if="!isDetail()">
				<div class="title">
					{{ $t("headerMainTitle") }}
				</div>
				<div class="tab-button-wrap">
					<template v-for="item of data">
						<div class="tab" v-if="isData(item.key)" :class="{'active': activeTab === item.key}"
							 @click="setActiveTab(item.key)">
							{{ item.alias }}
						</div>
					</template>
				</div>
			</div>
		</div>
		<div class="content-wrap">
			<div class="breadcrumbs" v-if="isDetail()">
				<div class="links">
					<router-link to="/">Marketplace</router-link>
					<span class="delimiter"></span>
					<span v-text="getCrumb()"></span>
				</div>
				<div class="back-btn">
					<router-link to="/">{{ $t("backBtn") }}</router-link>
				</div>
			</div>
			<div class="content" :class="{'detail': isDetail()}">
				<router-view :data="getData()"/>
			</div>
		</div>

		<div class="footer">
			<div class="container">
				<div class="footer-section logo">
					<img class="logo" src="@/styles/images/Retail7_RGB_white.svg" alt="retail7">
				</div>
				<div class="footer-section" v-for="item of footerStructure[country]">
					<p v-if="item.title" class="ttl">{{ $t(`footer.${item.title}`) }}</p>
					<ul class="footer-menu" v-if="item.entries && item.entries.length > 0"
						v-for="entry of item.entries">
						<li v-if="entry.title"><span class="section-name">{{ $t(`footer.${entry.title}`) }}</span></li>
						<li v-if="entry.entries && entry.entries.length > 0" v-for="link in entry.entries">
							<template v-if="footerLinks[country][link]">
								<a :href="footerLinks[country][link]" target="_blank">{{ $t(`footer.${link}`) }}</a>
							</template>
							<template v-else>
								{{ $t(`footer.${link}`) }}
							</template>
						</li>

					</ul>
				</div>
				<div class="footer-section copyright">
					<span>
						{{ $t("footer.copyright") }}
					</span>
				</div>
				<div class="footer-section sn">
					<div class="social-networks">
						<a href="https://twitter.com/retail7_pos" target="_blank">
							<i class="icon fa-brands fa-twitter-square"></i>
						</a>
						<a href="https://www.facebook.com/retail7pos" target="_blank">
							<i class="icon fa-brands fa-facebook-square"></i>
						</a>
						<a href="https://www.instagram.com/retail7_pos" target="_blank">
							<i class="icon fa-brands fa-instagram-square"></i>
						</a>
						<a href="https://www.youtube.com/channel/UCGSmdEQddffseAbGihTIE_Q?disable_polymer=true"
						   target="_blank">
							<i class="icon fa-brands fa-youtube-square"></i>
						</a>
						<a href="https://www.linkedin.com/company/retail7pos/" target="_blank">
							<i class="icon fa-brands fa-linkedin"></i>
						</a>
						<a href="https://www.xing.com/companies/retail7" target="_blank">
							<i class="icon fa-brands fa-xing-square"></i>
						</a>
					</div>
				</div>
				<div class="made-by">
					<span class="copyright">
						{{ $t("footer.copyright") }}
					</span>
					<p>made with <span class="r7-font-red">♥</span> by retail experts</p>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import MainView from "@/views/MainView";
import axios from "axios";
import DetailView from "@/views/DetailView";
import {footerLinks, footerStructure} from "@/locale/FooterLinks";
import {helperFunctions} from "@/main";

function getLang() {
	if (navigator.languages != undefined)
		return navigator.languages[0];
	return navigator.language;
}

export default {
	components: {MainView, DetailView},
	data() {
		return {
			data: [],
			activeTab: undefined,
			footerLinks,
			footerStructure,
			env: process?.env?.MARKETPLACE,
			country: "DE"
		};
	},
	methods: {
		setActiveTab: function(tabName) {
			if (this.activeTab && this.activeTab === tabName) {
				this.activeTab = undefined;
			} else {
				this.activeTab = tabName;
			}
		},
		getData: function() {
			if (this.activeTab !== undefined) {
				for (let dataItem in this.data) {
					if (this.data.hasOwnProperty(dataItem) && this.data[dataItem].key === this.activeTab) {
						const itemData = {};
						itemData[this.data[dataItem].key] = this.data[dataItem];
						return itemData;
					}
				}
			}
			return this.data;
		},
		isData: function(itemName) {
			return this.data && this.data.hasOwnProperty(itemName) && this.data[itemName].items && this.data[itemName].items.length > 0;
		},
		toMainPage: function() {
			this.activeTab = undefined;
			this.$router.push({name: "marketplace"})
		},
		isDetail: function() {
			return this.$route.name === "detail"
		},
		getCrumb: function() {
			return this.$route.params.detailName;
		}
	},
	async created() {
		this.country = helperFunctions.getCountryParam();
		const host = window.location.host;
		const domain = window.location.hostname === "localhost" ? "marketplace-admin.dev-retail7.com" : host.replace("marketplace", "marketplace-admin");
		const categories = await axios.get(`https://${domain}/api/v1/categories?country=${this.country}`);
		this.data = {};
		if (categories && categories.data && categories.data.length > 0) {
			for (let category of categories.data) {
				if (category && category.key && !this.data.hasOwnProperty(category.key)) {
					let offset = 0;
					const limit = 100;
					let response = await axios.get(`https://${domain}/api/v1/plugin-packages/?offset=${offset}&limit=${limit}&country=${this.country}&byCategory=${category.key}`);
					while (response && response.data && response.data.length > 0) {
						this.data[category.key] = category;
						this.data[category.key].index = Object.keys(this.data).length - 1;
						this.data[category.key].items = [];
						for (let item of response.data) {
							item.id = `${item.packageId.company}:${item.packageId.group}:${item.packageId.name}`;
						}
						this.data[category.key].items.push(...response.data);
						offset += response.data.length;
						response = await axios.get(`https://${domain}/api/v1/plugin-packages/?offset=${offset}&limit=${limit}&country=${this.country}&byCategory=${category.key}`);
					}
				}
			}
		}
		window.addEventListener('beforeunload', function(event) {
			(event || window.event).returnValue = "";
		});
	}
}
</script>

<style lang="less">
@import "styles/styles.less";
</style>
